import {
    apiRequest,
    CuttingCategoryList,
    CuttingCategoryInactive,
} from "../../../../../services/adapters/master/cuttingCategoryService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", CuttingCategoryList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    // fetchRowTable = async (query, cancelToken) => {
    //     return await apiRequest("get", acmanajerialList, {
    //         cancelToken: cancelToken,
    //         params: query
    //     }, true)
    // }

    fetchInactive = async (query) => {
        return await apiRequest("post", CuttingCategoryInactive, {
            body: query
        }, true)
    }

    // fetchActive = async (query) => {
    //     return await apiRequest("post", acmanajerialActive, {
    //         body: query
    //     }, true)
    // }
}

export default DataTableRepository